module.exports = __webpack_public_path__ + "img/icon6.8305b7d0.png";